import './MainPage-ThirdFrame-AboutUs.css';

export default function MainPageThirdFrame() {
    return (
        <div id="container-thirdframe">
            <div id='text-about-us'>
                <p>Acerca de Nosotros</p>
            </div>
            <div>
                <button id='btn-read-more'>Leer mas</button>
            </div>
        </div>
    );
}